export enum DtoTransactionState {
  TransactionStart = 'TransactionStart',
  UpdateDtoFlowStarting = 'UpdateDtoFlowStarting',
  Validating = 'Validating',
  CollectingSignatures = 'CollectingSignatures',
  BankerReviewing = 'BankerReviewing',
  BankerFinalReviewing = 'BankerFinalReviewing',
  Cancelled = 'Canceled', // FIXME: Canceled is a typo on server side
  Error = 'Error',
}
